import React from "react";
import { Heading, CartItems, T } from "../components/helpful";

/* The Cart class in JavaScript extends React.Component and renders a cart page with a heading,
subheading, and cart items. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/
export default class Cart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: <T value={"Download Cart"} />,
      isAllSelected: false,
    };
    
    this.myInputRef = React.createRef();
    this.subHeading = this.subHeading.bind(this);
  }

  subHeading = () => {
    return <>(Maximum Cart Size: <b>25MB</b>)</>;
  };

  render() {
    return (
      <div>
        <div className="">
          <div className="sticky-top">
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>
          <div className="main-content">
            <CartItems />
          </div> 
        </div>
      </div>
    );
  }
}
